export default __webpack_public_path__ + "static/media/52.53ea74ad.jpeg";